import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HumanResourceService } from '../../services/human-resource.service';
import { MasterDataService } from '../../services/master-data.service';
import * as html2pdf from 'html2pdf.js';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CommonMessageService } from 'src/app/services/common-message.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-my-actual-task-report',
  templateUrl: './my-actual-task-report.component.html',
  styleUrls: ['./my-actual-task-report.component.css']
})
export class MyActualTaskReportComponent implements OnInit {
  selectedFinancialYear;
  financialList;
  selectEmpStatus;
  employeeList;
  selectEmpName;
  selectedClientStatus;
  userRole;
  userId;
  clientList;
  selectedAssignment;
  assignmentList;
  selectClient;
  selectedBranch;
  branchList;
  reportList = [];
  showInputs: boolean;
  isClientSelected: boolean;
  isAssignmentSelected: boolean;
  routeUrlName;

  constructor(private humanResourceService: HumanResourceService,
    private masterDataService: MasterDataService,private commonMessageService:CommonMessageService,
    private activatedroute: ActivatedRoute) { }

  ngOnInit(): void {
    this.selectEmpStatus = "1";
    this.selectEmpName = "";
    this.selectClient = "";
    this.selectedAssignment = "";
    this.selectedFinancialYear = "";
    this.userId = localStorage.getItem('id');
    this.userRole = localStorage.getItem('droles');

    this.routeUrlName = this.activatedroute.snapshot.routeConfig.path;
    console.log('routing id', this.routeUrlName);

    console.log('userrole', this.userRole, this.userId);
    if (this.userRole == 'Partner' && this.routeUrlName == "actual-task-report") {
      this.showInputs = true;
      this.loadEmployeeProfiles();
      this.loadBranchDetails();
      this.selectedClientStatus ="";
    } else {
      this.showInputs = false;
      this.selectedClientStatus ="Active";
      this.loadClientDetails();
    }

  }

  loadEmployeeProfiles() {
    this.humanResourceService.getEmployeeProfile(this.selectEmpStatus).subscribe((res: any) => {
      this.employeeList = res;
      console.log('employee list', this.employeeList);
    });
  }

  loadBranchDetails() {
    this.masterDataService.getBranch().subscribe((res) => {
      this.branchList = res;
    });
  }

  onEmployeeSelect() {
    this.selectClient = [];
    this.selectedAssignment = [];
    this.selectedFinancialYear = "";
    // this.selectedClientStatus = "";
    if (this.selectEmpName != null && this.selectEmpName != "") {
      this.humanResourceService.getBranchByEmpProfile(this.selectEmpName.id).subscribe((resp: any) => {
        console.log('branch resp', resp.userOfficialDetails.branch.name);
        this.selectedBranch = resp.userOfficialDetails.branch.name;
      });
    }
  }


  employeeId;
  loadClientDetails() {
    if (this.showInputs == true) {
      this.employeeId = this.selectEmpName.id;
    } else {
      this.employeeId = this.userId;
    }
    if (this.selectedClientStatus != null && this.selectedClientStatus != "") {
      this.humanResourceService
        .getClientsByEmployeeAndStatus(this.employeeId, this.selectedClientStatus)
        .subscribe((res: any) => {
          console.log('client response details', res);
          this.clientList = res;
        });
    }
  }

  clientId;
  onSelectClient() {
    this.selectedAssignment = [];
    this.selectedFinancialYear = "";
    if (this.selectClient != null && this.selectClient.length > 0) {
        this.clientId = this.selectClient.map(({ id }) => id);
      console.log('cient id', this.clientId, this.selectClient);
      this.humanResourceService
        .getAssignmentsByMultipleClient(this.employeeId, this.clientId)
        .subscribe((res) => {
          this.assignmentList = res;
        });
    }
  }

  onSelectAssignment() {
    this.selectedFinancialYear = "";
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  selectAllClient(select: NgModel, values) {
    this.selectAll(select, values, this.isClientSelected);
    this.isClientSelected = !this.isClientSelected;
    this.onSelectClient();
  }

  selectAllAssignment(select: NgModel, values) {
    this.selectAll(select, values, this.isAssignmentSelected);
    this.isAssignmentSelected = !this.isAssignmentSelected;
    this.onSelectAssignment();
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  setRowSpanForBranchDetails(clientDetail) {
    var count = 0;
    clientDetail.assignments.map((res1: any) => {
      res1.task.map((res2: any) => {
        count++;
      });
    });
    return count;
  }

  clientTaskTotal;
  getClientWiseTaskTotal(assignmentDetail) {
    this.clientTaskTotal = 0;
    assignmentDetail.task.map((res: any) => {
      this.clientTaskTotal = this.clientTaskTotal + res.days;
    });
    return Math.round(this.clientTaskTotal);
  }

  allDaysTotal;
  assignmentId;
  showExportToExcelButton: boolean;
  assignmentForFy;
  onViewReport() {
    var total = 0;
    console.log(this.selectEmpName, this.selectedFinancialYear, this.selectClient, this.selectedAssignment);
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectClient == null ||
      this.selectClient.length == 0 ||
      this.selectedAssignment == null ||
      this.selectedAssignment.length == 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('','Please choose all the values');
      return;
    }

    this.assignmentId = this.selectedAssignment.map(({ id }) => id);
    console.log('clientId', this.clientId, 'Assignment id', this.assignmentId);

    this.masterDataService.getMyActualTaskDetails(this.employeeId, this.selectedFinancialYear.id, this.clientId, this.assignmentId).subscribe((resp: any) => {
      console.log('my actual task response', resp);
      if (resp.clients != null) {
        this.reportList = resp.clients;
        this.assignmentForFy = resp.assignmentForFy;
        this.showExportToExcelButton = true;
      } else {
        this.commonMessageService.swalAlertWithoutIcon('','No Record Found');
        this.showExportToExcelButton = false;
        this.reportList = [];
      }
      this.reportList.map((res1) => {
        res1.assignments.map((res2) => {
          res2.task.map((res3) => {
            total = total + res3.days
            this.allDaysTotal = Math.round(total);
          });
        });
      });
      console.log('all days total', this.allDaysTotal);
    });
  }

  exportToExcelMyActualTask() {
    this.masterDataService.getMyActualTaskExcel(this.employeeId, this.selectedFinancialYear.id, this.clientId, this.assignmentId).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "MyActualTaskReport.xlsx";
      link.click();
    });
  }

  // exportAsPDFMyActualTask() {
  //   var element = document.getElementById('elementsForPDF');
  //   var opt = {
  //     //  margin:  1,
  //     filename: 'MyActualTaskReport.pdf',
  //     image: { type: 'jpeg' },
  //     html2canvas: {},
  //     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  //   };
  //   html2pdf().from(element).set(opt).save();
  // }

  exportAsPDFMyActualTask() {
    var body = [];
    body.push([{ text: 'Client', style: 'headerStyle' }, { text: 'Assignment', style: 'headerStyle' }, { text: 'Task', style: 'headerStyle' }, { text: 'Days', style: 'headerStyle' }]);
    for (let i = 0; i < this.reportList.length; i++) {
      var taskSize = 0;
      for (let j = 0; j < this.reportList[i].assignments.length; j++) {
        taskSize = taskSize + this.reportList[i].assignments[j].task.length;
      }
      for (let j = 0; j < this.reportList[i].assignments.length; j++) {
        var totalDays = 0;
        for (let k = 0; k < this.reportList[i].assignments[j].task.length; k++) {
          var row = [
            { text: this.reportList[i].client, rowSpan: taskSize + this.reportList[i].assignments.length },
            { text: this.reportList[i].assignments[j].assignment, rowSpan: this.reportList[i].assignments[j].task.length },
            { text: this.reportList[i].assignments[j].task[k].task },
            { text: this.reportList[i].assignments[j].task[k].days }
          ]
          body.push(row)
          totalDays = totalDays + this.reportList[i].assignments[j].task[k].days;
          if (k == this.reportList[i].assignments[j].task.length - 1) {
            var totalRow = []
            totalRow = ['', { text: 'Total', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${Math.round(totalDays)}`, fillColor: '#e1f4f7' }]
            body.push(totalRow)
          }
        }
      }
      // var totalRow = ['', { text: 'Total', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, {
      //   text: `${this.reportList[i].assignments.map((asignment: any) => {
      //     var daysTotal = 0;
      //     asignment.task.map((taskName: any) => {
      //       daysTotal = daysTotal + taskName.days;
      //     })
      //     return daysTotal;
      //   })}`, fillColor: '#e1f4f7'
      // }]
      // body.push(totalRow)
    }

    body.push([{ text: 'Total', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: `${Math.round(this.allDaysTotal)}`, style: 'alltotalStyle' }])

    console.log('rows array', body);
    let docDefinition = {
      info: { title: 'My Actual Task Report' },
      pageOrientation: 'landscape',
      content: [
        { text: 'P G BHAGWAT LLP, Chartered Accountants', style: 'header' },
        { text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', style: 'header1' },
        { text: 'My Actual Tasks', style: 'header2' },
        { text: `AsgForFY :${this.assignmentForFy}`, style: 'header3' },
        {
          // border: [true, true, true, true],

          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*'],
            body: body
          },
          // layout: 'noBorders'
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
        },
        header1: {
          alignment: 'center',

        },
        header2: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 10, 0, 5],
        },
        header3: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 10],
        },
        headerStyle: {
          fillColor: '#17a2b8 !important',
          color: 'white',
          margin: [8, 8, 8, 8],
          fontSize: 14,
          bold: true,
        },
        alltotalStyle: {
          fillColor: '#e1f4f7',
          margin: [0, 5, 0, 5],
        },
        // tableStyle: {
        //   border: [true, true, true, true],
        //   // color: 'red'
        // }
      }
      // Common Styles  
    }
    pdfMake.createPdf(docDefinition).download('MyActualTaskReport.pdf');
  }
}
